import React from 'react';

export const Header = (props) => {
  return (
    <header className="main-header">

      {/* Top Blue Ribbon */}
      <div className="top-ribbon">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="ribbon-text">
            Book Your Online Request
          </div>

          <div className="ribbon-phone">
            <a href="tel:18008917531">📞 18008917531</a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="navbar-area">
        <div className="container">
          <div className="d-flex align-items-center w-100">
            {/* Logo */}
            <div className="logo">
              <a href="/">
                <img src="/img/logo.png" alt="RO Service Center" />
              </a>
            </div>

            {/* Call Button */}
            <div className="call-btn">
              <a href="tel:18008917531" className="call-button">
                <span>CALL NOW</span>
              </a>
            </div>

          </div>
        </div>
      </div>

    </header>
  )
}
